<template>
  <div class="col-md-12 bank_payment_list">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="form_select">
          <WrapDatePicker
              type="date"
              :placeholder="translate('bank_payment.period')"
              v-model="filter.date"
              :range="true"
              :confirm="true"
              :disabled_date="['- 24 month', 'now']"
              value_type="YYYY-MM-DD"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <tree-select
              :options="client_list"
              :multiple="true"
              v-model="filter.client_ids"
              :placeholder="translate('bank_payment.client_name')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <fg-input
              v-model="filter.inn"
              type="text"
              :placeholder="translate('bank_payment.inn')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select">
          <fg-input
              v-model="filter.ur_name"
              type="text"
              :placeholder="translate('bank_payment.ur_name')"
              :clearable="true"
              @input="change_input"
          />
        </div>

        <div class="form_select"></div>
        <div class="form_select">
          <button type="button" class="btn btn-info btn-fill" @click="show_import">
            {{ translate('bank_payment.import.button') }}
          </button>
        </div>
      </div>
    </div>

    <div class="response_table">
      <div v-if="import_result" class="summary card" role="status">
        <p>{{ translate('bank_payment.import.success') }}</p>
        <p v-for="key in ['parsed', 'created', 'skipped_duplicates', 'skipped_invalid']" :key="key">
          <span>{{ translate('bank_payment.import.' + key) }}:</span>
          <span>{{ import_result[key] }}</span>
        </p>
      </div>
      <div class="summary card" v-if="summary.length > 0">
        <p v-for="(sum, key) in summary" :key="key">
          <span>{{ translate("bank_payment.summary." + sum.name) }}:</span>
          <span v-html="sum.value" />
        </p>
      </div>

      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th
                class="pointer"
                @click="change_filter('date')"
                :class="{ selected: filter_type === 'date' }"
                scope="col"
            >
              {{ translate('bank_payment.date') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer text-right"
                @click="change_filter('sum')"
                :class="{ selected: filter_type === 'sum' }"
                scope="col"
            >
              {{ translate('bank_payment.sum') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer text-left"
                @click="change_filter('inn')"
                :class="{ selected: filter_type === 'inn' }"
                scope="col"
            >
              {{ translate('bank_payment.inn') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer text-left"
                @click="change_filter('ur_name')"
                :class="{ selected: filter_type === 'ur_name' }"
                scope="col"
            >
              {{ translate('bank_payment.ur_name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'asc' }"
              />
            </th>
            <th
                class="pointer text-left"
                @click="change_filter('client_name')"
                :class="{ selected: filter_type === 'client_name' }"
                scope="col"
            >
              {{ translate('bank_payment.client_name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('ts_create')"
                :class="{ selected: filter_type === 'ts_create' }"
                scope="col"
            >
              {{ translate('bank_payment.ts_create') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'asc' }"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <BankPaymentItem
              v-for="(bank_payment,key) in payment_list"
              :key="key"
              :bank_payment="bank_payment"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import BankPaymentItem from "../../Item/Index.vue";
import ModalImport from "../../Modal/Import.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'BankPayments',
  components: {
    WrapDatePicker,
    BankPaymentItem
  },
  data () {
    return {
      bank_payment_list: [],
      import_result: null,
      check_link: true,
      filter:{
        date: [],
        client_ids: [],
        inn: "",
        ur_name: ""
      },
      filter_asc: "asc",
      filter_type: "",
      summary: {},
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  computed:{
    sended_filter() {
      let filter = {};
      Object.keys(this.filter).forEach((key) => {
        if (key === 'client_ids'){
          if (this.filter.client_ids.length > 0) filter.client_ids = this.filter.client_ids
        } else if (key === 'date' && this.filter[key][0] && this.filter[key][1]){
          filter.date_start = this.filter[key][0]
          filter.date_end = this.filter[key][1]
        } else {
          if (this.filter[key] !== "" && this.filter[key] !== null && this.filter[key] !== undefined){
            filter[key] = this.filter[key]
          }
        }
      })
      return filter;
    },
    payment_list(){
      let payment_list = [...this.bank_payment_list];
      return payment_list.sort(this.compareNumbers);
    },
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return { id: client.id, label: client.name }
      })
    },
  },

  watch:{
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'bank_payment_list_section' && this.$route.params.bank_payment_list_section === 'payments') {
          let string = '?'

          for (let key in this.filter) {
            if (key === 'client_ids' && this.filter[key].length > 0) {
              string += '&' + key + '=' + this.filter[key].join(',')
            }
          }
          history.pushState(null, null, this.$route.path + string)
        }
      }
    },
  },
  activated () {
    this.check_query()
  },

  methods: {
    show_import() {
      let t = this.$createElement(ModalImport, {
        on: {
          update: (result) => {
            this.import_result = result
            this.load_bank_payments()
            this.$modal.hide('modal_import_bank_payments')
          },
          close: () => {
            this.$modal.hide('modal_import_bank_payments')
          }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'modal_import_bank_payments'})
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.load_bank_payments, 500)
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'client_ids':
              this.filter.client_ids = String(this.$route.query[key]).split(',').filter(Boolean).map(Number)
              break;
            case 'client_id':
              if (this.$route.query.client_ids === undefined) {
                this.filter.client_ids = String(this.$route.query[key]).split(',').filter(Boolean).map(Number)
              }
              break;
            }
        }
      }
      this.load_bank_payments()
    },
    load_bank_payments(){
      this.$http.v1.getBankPaymentList(this.sended_filter, (response) => {
        if (response.data){
          this.bank_payment_list = response.data.data
          this.summary = response.data.summary
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>

.bank_payment_list{
  height: 100%;
  display: flex;
  flex-direction: column;

  .main_filters{
    top: 20px;
  }

  .import_payments{
    margin-top: 10px;
  }

  .header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex: 1;
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .filter{
      margin: 0;
    }
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 2;

      .btn{
        width: 30%;
      }
    }
    .form_select{
      flex: 1;
      .vue-treeselect{
        margin-bottom: 0;
      }
      .form-group{
        margin: 0;
      }
      .btn{
        width: 100%;
      }
    }
  }

  .bank_payment{
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
    td{
      overflow: hidden;
    }
  }
  .response_table{
    flex: 10;
    padding: 10px 0 0;
    table{
      th.text-left{
        text-align: left;
      }
      th.text-right{
        text-align: right;
      }
      th, td {
        font-size: 12px;
      }
    }
  }
}
</style>
